import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  FaChevronLeft,
  FaChevronRight,
  FaEllipsisH,
  FaPlus,
  FaImages,
  FaBorderAll,
  FaLink,
  FaRegFile,
  FaRegWindowRestore,
  FaDice,
  FaCogs,
  // FaCalendarAlt,
} from 'react-icons/fa';
import {
  TiSortNumerically,
  TiSortAlphabetically,
  TiFilter,
} from 'react-icons/ti';
import { RxDividerHorizontal } from 'react-icons/rx';
import { MdSmartButton } from 'react-icons/md';
import { useSelector, useDispatch } from 'react-redux';
import { TooltipHtml } from '../tooltip/tooltip.Html';
import {
  addCondition,
  addDivider,
  addFilter,
  addDice,
  addGenerator,
  getItemGenerators,
  addIframe,
  addInTab,
  addNum,
  addPic,
  addText,
  addTimeline,
  // addDate,
  update,
} from '../../services/item';
import { setOpenModales, setSidebarOpen } from '../../store/global';
import { SearchModal } from '../search/search.Modal';
import { getId } from '../../utils/item';
import { deepCloneArray } from '../../utils/array';
import { LinkNewBoard } from '../link/link.NewInBoard';
import { canUseMjForItem, isMjForItem } from '../../utils/auth';
import { LinkNew } from '../link/link.New';
import { TabNew } from '../tab/tab.New';
import { FaRegClock } from 'react-icons/fa';
import { renderIconBySlug } from '../../content/icons';
import { attachNodeToGroups } from '../board/boardDrawAdditions';

export const ItemToolBox = props => {
  const {
    itemId,
    displayType,
    currentBoard,
    hasBoard,
    onSidebarClose,
    activeDrawGroupId,
  } = props;

  const isMobile = useSelector(state => state.global.isMobile);
  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const canMj = isMjForItem(item, items) || canUseMjForItem(item, items);
  const tab = useSelector(state => state.items[currentBoard]);
  const dispatch = useDispatch();

  const [displayGridsList, setDisplayGridsList] = useState(null);
  const [searchQuery, setSearchQuery] = useState({});
  const [showMoreWidgets, setShowMoreWidgets] = useState(false);
  const showSidebarTabPicker =
    displayType === 'sidebar' || displayType === 'drawer';
  const paginateWidgetToolbox =
    (displayType === 'sidebar' || displayType === 'drawer') && hasBoard;
  const showToolboxTail = paginateWidgetToolbox && showMoreWidgets;
  const showHeadWidgets = !paginateWidgetToolbox || !showToolboxTail;
  const showTailWidgets = !paginateWidgetToolbox || showToolboxTail;
  const boardWidgetHeadTools = [
    { icon: <TiSortNumerically />, type: 'has_num', add: addNum },
    { icon: <MdSmartButton />, type: 'conditions', add: addCondition },
  ];
  const boardWidgetTailTools = [
    { icon: <FaRegWindowRestore />, type: 'iframes', add: addIframe },
    { icon: <TiFilter />, type: 'filters', add: addFilter },
    { icon: <FaRegClock />, type: 'timelines', add: addTimeline },
    { icon: <FaDice />, type: 'dice', add: addDice },
    { icon: <FaCogs />, type: 'generator', add: addGenerator },
  ];

  const addInActiveBoard = (idToAdd, type) => {
    addInTab(idToAdd, type, item, tab);
    if (!activeDrawGroupId || !tab?._id) {
      return;
    }
    const nextGroups = attachNodeToGroups({
      groups: Array.isArray(tab?.draw?.groups)
        ? deepCloneArray(tab.draw.groups)
        : [],
      activeGroupId: activeDrawGroupId,
      nodeId: `widget:${idToAdd}`,
      rect: null,
    });
    update(`items/${tab._id}`, 'draw.groups', nextGroups);
  };

  const handleSearchChange = (type, value) => {
    setSearchQuery(prev => ({
      ...prev,
      [type]: value,
    }));
  };

  const typeDisplay = type => {
    if (tab) {
      const arr =
        type === 'dice'
          ? item?.dices || []
          : type === 'generator'
            ? item?.generators || []
            : item?.[type] || [];
      let label;
      let labelText;
      const layout = Array.isArray(tab?.grid)
        ? tab.grid.map(gridObj => gridObj[getId(gridObj)])
        : [];
      const normalizedSearch = searchQuery?.[type]?.toLowerCase()?.trim();
      // eslint-disable-next-line
      return arr.map(objDisplay => {
        const display = objDisplay[getId(objDisplay)];
        let displayElement =
          layout.findIndex(
            element =>
              element.i === getId(objDisplay) && element.item === itemId,
          ) === -1;
        if (type === 'text') {
          const textValue = String(display?.text || '');
          const trimmedTextValue = textValue.trim();
          label = trimmedTextValue
            ? `${trimmedTextValue.slice(0, 35)}...`
            : 'texte vide';
          labelText = trimmedTextValue || 'texte vide';
        }
        if (type === 'pics') {
          label = display?.iconSlug ? (
            renderIconBySlug(display.iconSlug, {
              size: 30,
              color: 'var(--contrast)',
            })
          ) : (
            <img
              alt='pic'
              src={display.url}
              style={{ height: 30 }}
              className='rounded'
            />
          );
          labelText = display?.label || display?.url || '';
        }
        if (type === 'has_num') {
          label = display?.label;
          labelText = display?.label;
        }
        if (type === 'date') {
          label = display.label;
          labelText = display?.label;
        }
        if (type === 'conditions') {
          label = display.active.label;
          labelText = display?.active?.label;
        }
        if (type === 'iframes') {
          const url = display.url;
          const domaine = url
            ?.split('/')[2]
            ?.replace('www.', '')
            ?.split('.')?.[0];
          label = display?.label ?? domaine ?? 'iframe';
          labelText = display?.label || domaine || url || '';
        }
        if (type === 'filters') {
          label = display.label;
          labelText = display?.label;
        }
        if (type === 'timelines') {
          label = display?.label || 'timeline';
          labelText = display?.label || 'timeline';
        }
        if (type === 'dice') {
          label = display?.label || 'de';
          labelText = display?.label || 'de';
        }
        if (type === 'generator') {
          label = display?.label || 'générateur';
          labelText = display?.label || 'générateur';
        }
        const matchesSearch =
          !normalizedSearch ||
          (labelText || '')?.toLowerCase()?.includes(normalizedSearch);
        if (displayElement && matchesSearch) {
          return (
            <div
              className='flex items-center p-05 transition hover:opacity-50 cursor-pointer'
              onClick={() => addInActiveBoard(Object.keys(objDisplay)[0], type)}
              key={Object.keys(objDisplay)[0]}
            >
              {label}
            </div>
          );
        }
      });
    }
  };

  useEffect(() => {
    if (item?.tabs) {
      const gridTabs = new Set(
        item.tabs.map(
          objTab =>
            objTab[Object.keys(objTab)].display === 'grid' &&
            objTab[Object.keys(objTab)],
        ),
      );
      gridTabs.delete(false);
      setDisplayGridsList(Array.from(gridTabs));
    }
    // eslint-disable-next-line
  }, [item?.tabs]);

  useEffect(() => {
    if (!item?._id) {
      return;
    }
    getItemGenerators(item._id).catch(() => null);
  }, [item?._id]);

  useEffect(() => {
    if (!paginateWidgetToolbox) {
      setShowMoreWidgets(false);
    }
  }, [paginateWidgetToolbox]);

  return (
    <div className='text-contrast flex gap-1 items-center justify-center'>
      <SearchModal item={item} />
      {showHeadWidgets && showSidebarTabPicker && (
        <TooltipHtml
          title={
            <div>
              {displayGridsList?.map(tab => (
                <div
                  key={tab._id}
                  className={`${
                    item?.sidebar === tab._id ? 'text-secondary' : ''
                  } cursor-pointer transition hover:opacity-50`}
                  onClick={() => update(`items/${itemId}`, 'sidebar', tab?._id)}
                >
                  {items[tab?._id]?.label}
                </div>
              ))}
              <div
                className='cursor-pointer transition hover:opacity-50'
                onClick={() => update(`items/${itemId}`, 'sidebar', null)}
              >
                affichage par défaut
              </div>
              <div
                className='cursor-pointer flex items-center justify-center transition hover:opacity-50'
                onClick={e => {
                  e.stopPropagation();
                  dispatch(setOpenModales({ id: 'addTab', open: true }));
                }}
              >
                <TabNew itemId={itemId} /> Ajouter un onglet
              </div>
            </div>
          }
        >
          <div>
            <FaBorderAll />
          </div>
        </TooltipHtml>
      )}

      {showHeadWidgets && (
        <TooltipHtml
          title={
            <div
              className='flex flex-wrap text-contrast overflow-x-hidden overflow-y-auto'
              style={{ maxHeight: 400 }}
            >
              {hasBoard ? (
                <>
                  <div
                    className='w-full gap-1 flex items-center cursor-pointer transition hover:opacity-50'
                    onClick={() => addPic(item, tab, addInTab)}
                  >
                    <FaPlus /> Nouveau
                  </div>
                  <div className='w-full mt-05 mb-05'>
                    <input
                      type='text'
                      value={searchQuery?.pics || ''}
                      onChange={e => handleSearchChange('pics', e.target.value)}
                      placeholder='Rechercher...'
                      className='w-full rounded bg-transparent border border-contrast border-opacity-20 px-1 py-05 text-xs text-contrast placeholder-contrast placeholder-opacity-40'
                    />
                  </div>
                  {typeDisplay('pics')}
                </>
              ) : (
                <div className='text-xs text-white py-05'>
                  ajouter une image à {item.label}
                </div>
              )}
            </div>
          }
        >
          <div
            className='cursor-pointer transition hover:opacity-50'
            onClick={() => addPic(item, tab, addInTab)}
          >
            <FaImages />
          </div>
        </TooltipHtml>
      )}

      {showHeadWidgets && (
        <TooltipHtml
          title={
            <div
              className='flex flex-wrap text-contrast overflow-x-hidden overflow-y-auto'
              style={{ maxHeight: 400 }}
            >
              {hasBoard ? (
                <>
                  <div
                    className='w-full gap-1 flex items-center cursor-pointer transition hover:opacity-50'
                    onClick={() => addText(item, tab, addInTab)}
                  >
                    <FaPlus /> Nouveau
                  </div>
                  <div className='w-full mt-05 mb-05'>
                    <input
                      type='text'
                      value={searchQuery?.text || ''}
                      onChange={e => handleSearchChange('text', e.target.value)}
                      placeholder='Rechercher...'
                      className='w-full rounded bg-transparent border border-contrast border-opacity-20 px-1 py-05 text-xs text-contrast placeholder-contrast placeholder-opacity-40'
                    />
                  </div>
                  {typeDisplay('text')}
                </>
              ) : (
                <div className='text-xs text-white py-05'>
                  ajouter un texte à {item.label}
                </div>
              )}
            </div>
          }
        >
          <div
            className='cursor-pointer transition hover:opacity-50'
            onClick={() => addText(item, tab, addInTab)}
          >
            <TiSortAlphabetically />
          </div>
        </TooltipHtml>
      )}

      {hasBoard && (
        <>
          {showHeadWidgets &&
            boardWidgetHeadTools.map(e => (
              <TooltipHtml
                key={e.type}
                title={
                  <div
                    className='flex flex-wrap text-contrast overflow-x-hidden overflow-y-auto'
                    style={{ maxHeight: 400 }}
                  >
                    <div
                      className='w-full gap-1 flex items-center cursor-pointer transition hover:opacity-50'
                      onClick={() => e.add(item, tab, addInTab)}
                    >
                      <FaPlus /> Nouveau
                    </div>
                    <div className='w-full mt-05 mb-05'>
                      <input
                        type='text'
                        value={searchQuery?.[e.type] || ''}
                        onChange={event =>
                          handleSearchChange(e.type, event.target.value)
                        }
                        placeholder='Rechercher...'
                        className='w-full rounded bg-transparent border border-contrast border-opacity-20 px-1 py-05 text-xs text-contrast placeholder-contrast placeholder-opacity-40'
                      />
                    </div>
                    {typeDisplay(e.type)}
                  </div>
                }
              >
                <div className='cursor-pointer transition hover:opacity-50'>
                  {e.icon}
                </div>
              </TooltipHtml>
            ))}
          {showTailWidgets &&
            boardWidgetTailTools.map(e => (
              <TooltipHtml
                key={e.type}
                title={
                  <div
                    className='flex flex-wrap text-contrast overflow-x-hidden overflow-y-auto'
                    style={{ maxHeight: 400 }}
                  >
                    <div
                      className='w-full gap-1 flex items-center cursor-pointer transition hover:opacity-50'
                      onClick={() => e.add(item, tab, addInTab)}
                    >
                      <FaPlus /> Nouveau
                    </div>
                    <div className='w-full mt-05 mb-05'>
                      <input
                        type='text'
                        value={searchQuery?.[e.type] || ''}
                        onChange={event =>
                          handleSearchChange(e.type, event.target.value)
                        }
                        placeholder='Rechercher...'
                        className='w-full rounded bg-transparent border border-contrast border-opacity-20 px-1 py-05 text-xs text-contrast placeholder-contrast placeholder-opacity-40'
                      />
                    </div>
                    {typeDisplay(e.type)}
                  </div>
                }
              >
                <div className='cursor-pointer transition hover:opacity-50'>
                  {e.icon}
                </div>
              </TooltipHtml>
            ))}
          {showHeadWidgets && (
            <TooltipHtml
              title='ajouter une séparation'
            >
              <div
                className='cursor-pointer transition hover:opacity-50'
                onClick={() => addDivider(item, tab, addInTab)}
              >
                <RxDividerHorizontal />
              </div>
            </TooltipHtml>
          )}
          {showHeadWidgets && (
            <TooltipHtml title='ajouter un item'>
              <div
                className='cursor-pointer transition hover:opacity-50'
                onClick={() =>
                  dispatch(
                    setOpenModales({ id: 'addLink' + currentBoard, open: true }),
                  )
                }
              >
                <FaRegFile />
              </div>
            </TooltipHtml>
          )}
          <LinkNewBoard
            itemId={itemId}
            currentTabId={currentBoard}
          />
        </>
      )}

      {paginateWidgetToolbox && (
        <TooltipHtml
          title={showToolboxTail ? 'afficher le début' : 'afficher plus'}
        >
          <div
            className='cursor-pointer transition hover:opacity-50'
            onClick={() => setShowMoreWidgets(prev => !prev)}
          >
            <FaEllipsisH />
          </div>
        </TooltipHtml>
      )}

      {(displayType === 'drawer' || displayType === 'sidebar') && (
        <>
          {(!paginateWidgetToolbox || showHeadWidgets) && (
            <TooltipHtml title={'ajouter un lien à ' + item.label}>
              <div
                className='cursor-pointer transition hover:opacity-50'
                onClick={() =>
                  dispatch(setOpenModales({ id: 'addLink' + itemId, open: true }))
                }
              >
                <FaLink />
              </div>
            </TooltipHtml>
          )}
        </>
      )}
      <LinkNew itemId={itemId} />

      {displayType === 'drawer' && canMj && (
        <Link
          to={`../../item/${itemId}`}
          className='cursor-pointer transition hover:opacity-50'
        >
          <FaChevronRight />
        </Link>
      )}
      {displayType === 'sidebar' && isMobile === false && (
        <div
          className='cursor-pointer transition hover:opacity-50'
          onClick={() => {
            if (typeof onSidebarClose === 'function') {
              onSidebarClose();
            } else {
              dispatch(setSidebarOpen(false));
            }
          }}
        >
          <FaChevronLeft />
        </div>
      )}
    </div>
  );
};
